import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpMainService } from "../http-main.service";
import { OtpCodeResponseModel } from "@itb-monorepo/models";
import { OtpRequestModel } from "@itb-monorepo/models";

@Injectable()
export class AnnouncementService {
  baseUrl = '/announcement/';
  private _HttpMainService = inject(HttpMainService);


  sendOtpCode(model: OtpRequestModel, cfTrunsTile: string): Observable<OtpCodeResponseModel> {

    const header = { 'cf-turnstile-response': cfTrunsTile };

    return this._HttpMainService.post(this.baseUrl + "v1/codes", model, header);
  }


}
